import { FormattedMessage } from 'react-intl';
import { Flags } from './Flags';
import { ReactNode } from 'react';

const Languages: Record<
  string,
  { icon: React.ReactNode; label: ReactNode; text: string }
> = {
  bg: {
    icon: Flags.bulgaria,
    label: (
      <FormattedMessage id="bulgarian" defaultMessage="Bulgarian" />
    ),
    text: 'Bulgarian',
  },
  zh: {
    icon: Flags.china,
    label: <FormattedMessage id="chinese" defaultMessage="Chinese" />,
    text: 'Chinese',
  },
  hr: {
    icon: Flags.croatia,
    label: (
      <FormattedMessage id="croatian" defaultMessage="Croatian" />
    ),
    text: 'Croatian',
  },
  da: {
    icon: Flags.denmark,
    label: <FormattedMessage id="danish" defaultMessage="Danish" />,
    text: 'Danish',
  },
  nl: {
    icon: Flags.netherlands,
    label: <FormattedMessage id="dutch" defaultMessage="Dutch" />,
    text: 'Dutch',
  },
  en: {
    icon: Flags.england,
    label: <FormattedMessage id="english" defaultMessage="English" />,
    text: 'English',
  },
  fi: {
    icon: Flags.finland,
    label: <FormattedMessage id="finnish" defaultMessage="Finnish" />,
    text: 'Finnish',
  },
  fr: {
    icon: Flags.france,
    label: <FormattedMessage id="french" defaultMessage="French" />,
    text: 'French',
  },
  de: {
    icon: Flags.germany,
    label: <FormattedMessage id="german" defaultMessage="German" />,
    text: 'German',
  },
  el: {
    icon: Flags.greece,
    label: <FormattedMessage id="greek" defaultMessage="Greek" />,
    text: 'Greek',
  },
  es: {
    icon: Flags.spain,
    label: <FormattedMessage id="spanish" defaultMessage="Spanish" />,
    text: 'Spanish',
  },
  it: {
    icon: Flags.italy,
    label: <FormattedMessage id="italian" defaultMessage="Italian" />,
    text: 'Italian',
  },
  pt: {
    icon: Flags.portugal,
    label: (
      <FormattedMessage id="portuguese" defaultMessage="Portuguese" />
    ),
    text: 'Portuguese',
  },
  'pt-br': {
    icon: Flags.brazil,
    label: (
      <FormattedMessage
        id="portugueseBrazil"
        defaultMessage="Portuguese (Brazil)"
      />
    ),
    text: 'Portuguese (Brazil)',
  },
  no: {
    icon: Flags.norway,
    label: (
      <FormattedMessage id="norwegian" defaultMessage="Norwegian" />
    ),
    text: 'Norwegian',
  },
  sv: {
    icon: Flags.sweden,
    label: <FormattedMessage id="swedish" defaultMessage="Swedish" />,
    text: 'Swedish',
  },
  ru: {
    icon: Flags.russia,
    label: <FormattedMessage id="russian" defaultMessage="Russian" />,
    text: 'Russian',
  },
  tr: {
    icon: Flags.turkey,
    label: <FormattedMessage id="turkish" defaultMessage="Turkish" />,
    text: 'Turkish',
  },
  pl: {
    icon: Flags.poland,
    label: <FormattedMessage id="polish" defaultMessage="Polish" />,
    text: 'Polish',
  },
  et: {
    icon: Flags.estonia,
    label: (
      <FormattedMessage id="estonian" defaultMessage="Estonian" />
    ),
    text: 'Estonian',
  },
  hu: {
    icon: Flags.hungary,
    label: (
      <FormattedMessage id="hungarian" defaultMessage="Hungarian" />
    ),
    text: 'Hungarian',
  },
  ro: {
    icon: Flags.romania,
    label: (
      <FormattedMessage id="romanian" defaultMessage="Romanian" />
    ),
    text: 'Romanian',
  },
  sk: {
    icon: Flags.slovakia,
    label: <FormattedMessage id="slovak" defaultMessage="Slovak" />,
    text: 'Slovak',
  },
  vi: {
    icon: Flags.vietnam,
    label: (
      <FormattedMessage id="vietnamese" defaultMessage="Vietnamese" />
    ),
    text: 'Vietnamese',
  },
  ja: {
    icon: Flags.japan,
    label: (
      <FormattedMessage id="japanese" defaultMessage="Japanese" />
    ),
    text: 'Japanese',
  },
  ko: {
    icon: Flags.korea,
    label: <FormattedMessage id="korean" defaultMessage="Korean" />,
    text: 'Korean',
  },
  th: {
    icon: Flags.thailand,
    label: <FormattedMessage id="thai" defaultMessage="Thai" />,
    text: 'Thai',
  },
  id: {
    icon: Flags.indonesia,
    label: (
      <FormattedMessage id="indonesian" defaultMessage="Indonesian" />
    ),
    text: 'Indonesian',
  },
  cs: {
    icon: Flags.czech,
    label: <FormattedMessage id="czech" defaultMessage="Czech" />,
    text: 'Czech',
  },
};

export default Languages;
